import { env, wms_uploads_cdn } from "../Components/config";

export const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};

export const getProductImageUrl = (product) => {
    if (!product?.profile_image) return null;
    return `${wms_uploads_cdn}/${env}/warehouse-products/${product?.netsuite_id || product?.product_netsuite_id}/${product?.profile_image}`;
};

export const getBase64Image = async (url) => {
    try {
        const response = await fetch(url, { mode: "cors" });
        const blob = await response.blob(); 
        const reader = new FileReader();
        return await new Promise((resolve, reject) => {
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob); 
        });
    } catch (err) {
        console.error("Failed to convert image:", url, err);
        return ""; 
    }
}